import React from "react";

import { PrescreeningSettings } from "manager/components/Prescreening";
import { VeroGoBanner } from "manager/components/VeroGoBanner";
import { useGetDefaultPrescreeningDealSetup } from "manager/hooks/api/dealSetupQueries";
import SettingsPage from "manager/templates/SettingsPage";
import { usePermissions } from "shared/hooks";
import { BackLinkProps } from "shared/interfaces/misc";

interface CompanyPrescreeningSettingsProps {
  backLink: BackLinkProps;
}

const CompanyPrescreeningSettings = ({
  backLink,
}: CompanyPrescreeningSettingsProps) => {
  const { defaultPrescreeningDealSetup } = useGetDefaultPrescreeningDealSetup();
  const { isVeroGoEnabled } = usePermissions();
  return (
    <SettingsPage title="Prequalification Setup" backLink={backLink}>
      <VeroGoBanner
        show={isVeroGoEnabled && !!defaultPrescreeningDealSetup?.veroGoActive}
      />
      <PrescreeningSettings dealSetupId={defaultPrescreeningDealSetup?.id} />
    </SettingsPage>
  );
};

export default CompanyPrescreeningSettings;
